module.exports = __webpack_public_path__ + "static/media/aldi.6838ea65.png";